export enum Permission {
  StoreConfigsModify = 'store_configs.modify',
  StoreConfigsView = 'store_configs.view',
  Storefront = 'storefront',
  StorefrontStorefrontNavigationView = 'storefront_storefront_navigation.view',
  StorefrontPageBuilderModify = 'storefront_page_builder.modify',
  StorefrontPageBuilderView = 'storefront_page_builder.view',
  ReadOnly = 'revoke_writes.legacy_permission',
  StoreConfigurationDraftModify = 'store_configurations_draft.modify',
  StoreConfigurationDraftView = 'store_configurations_draft.view',
  AdminPanel = 'admin_panel.legacy_permission',
  AutosuggestModify = 'autosuggest_links.modify',
  AutosuggestView = 'autosuggest_links.view',
  DepartmentsView = 'retailer_collections_departments.view',
  DepartmentsModify = 'retailer_collections_departments.modify',
  CreativeManagerView = 'creative_manager.view',
  CreativeManagerModify = 'creative_manager.modify',
  StorefrontRetailerFundedMarketingView = 'storefront_retailer_funded_marketing.view',
  StorefrontRetailerFundedMarketingModify = 'storefront_retailer_funded_marketing.modify',
  CollectionsView = 'collections.view',
}
